module.exports = __webpack_public_path__ + "media/customizations/caymas/logo-new-53c382e2dadefc9d017cd212497eb97f.png";